// extracted by mini-css-extract-plugin
export default {"numericControl":"NumericControl-module__numericControl__FtqXd","textControl":"NumericControl-module__textControl__cUIB0","leftIcon":"NumericControl-module__leftIcon__BXaA8"};